import { render } from "./TvmWebIframeRedirect.vue?vue&type=template&id=40961428&scoped=true"
import script from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"
export * from "./TvmWebIframeRedirect.vue?vue&type=script&lang=js"

import "./TvmWebIframeRedirect.vue?vue&type=style&index=0&id=40961428&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40961428"],['__file',"src/components/ChatWidget/TvmWebIframeRedirect/TvmWebIframeRedirect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40961428"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40961428', __exports__)) {
    api.reload('40961428', __exports__)
  }
  
  module.hot.accept("./TvmWebIframeRedirect.vue?vue&type=template&id=40961428&scoped=true", () => {
    api.rerender('40961428', render)
  })

}


export default __exports__